import { patchUsersIdPreferencesSection } from '../api/generated/arrayscapeGamingDashboardAPI';
import { UserPreferences, ColumnConfig } from '../api/generated/model';

class UserPreferencesService {
  async updateTableColumnOrder(userId: string, tableName: string, columnConfigs: ColumnConfig[]) {
    return patchUsersIdPreferencesSection(userId, 'table_column_orders', {
      [tableName]: columnConfigs
    });
  }

  async updateTableColumnWidths(userId: string, tableName: string, columnWidths: Record<string, number>) {
    return patchUsersIdPreferencesSection(userId, 'table_column_widths', {
      [tableName]: columnWidths
    });
  }

  async updateExportFieldMappings(userId: string, exportType: string, fieldMappings: Record<string, string>) {
    return patchUsersIdPreferencesSection(userId, 'export_field_mappings', {
      [exportType]: fieldMappings
    });
  }
}

export const userPreferencesService = new UserPreferencesService();
export type { UserPreferences };
